<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Border Lord</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm02"><div class="chapterHead"><a id="page02"></a></div><div class="chapterBody"><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="chapterOpenerText"><a id="page02"><span>Dear Reader,</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>Harlequin is sixty years young this year…a vibrant energetic company spinning dreams and fantasies for all those readers who love to escape for a while from the busy reality of life…. Congratulations on such a milestone!</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>As a writer for Harlequin Historical, I have always been fascinated by the emotions around love. The inspiration for <em class="italic"><span>The Border Lord</span></em> came from the lonely face of a Scottish warrior I saw portrayed in a painting at the visitor center on Culloden Field.</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>With the lines of loss, war and battle drawn upon him I wondered about the state of his soul and about the possibility of him meeting a woman who might heal his grief and make him whole again.</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>Redemption, passion and loyalty…all the emotions that make Harlequin Historical novels such wonderful books to read.</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>On the cover of <em class="italic"><span>The Border Lord</span></em> is the popular TV personality Colin McAllister.</span></a></p><p class="lineSpace1"><a id="page02"><span> </span></a></p><p class="paraNoIndent"><a id="page02"><span>Sophia</span></a></p></div></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// borderlordthe_fm02.vue?2bbe053d